module.exports = __webpack_public_path__ + "static/efadp_logo_color_02-ba6acd642c6a081489a6ada5d1bf8eb5.jpg";